import React, { useState, useRef, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Link } from "react-router-dom";
import * as api from "./../../api/api";
import Logo from "./../../assets/images/logo.png";
import { useHistory } from "react-router-dom";
import Company from "./../register/companyDetails";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

const initialFormData = {
  email: "",
  password: "",
};
export default function Login() {
  const classes = useStyles();
  const history = useHistory();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [formData, setFormData] = useState(initialFormData);
  const [company, setCompany] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [errorPassword, setErrorPassword] = useState("");
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    document.title = "121five.com - Login";
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    setLoader(true);
    if (simpleValidator.current.allValid()) {
      try {
        const reqObj = {};
        reqObj.email = formData.email;
        reqObj.password = formData.password;

        const response = await api.login(reqObj);

        if (response.status === 201) {
          setErrorPassword("");
          if (response.data.company_not_exist === 0) {
            localStorage.setItem("isAuth", true);
            localStorage.setItem("userName", response.data.name);
            localStorage.setItem("email", response.data.email);
            localStorage.setItem("id", response.data.id);
            history.push({
              pathname: "/dashboard",
              state: { userData: response.data },
            });

            // setLoader(false);
            // window.location.reload();
          } else {
            setId(response.data.id);
            setName(response.data.name);
            setCompany(true);
            setLoader(false);
          }
        } else {
          setErrorPassword(response.data.message);
          setLoader(false);
        }
      } catch (e) {}
    } else {
      simpleValidator.current.showMessages();
      setLoader(false);
    }
  };
  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth">
          <div className="row flex-grow">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left p-5">
                <Link to="/">
                  <div className="brand-logo">
                    <img src={Logo} alt="Logo" />
                  </div>
                </Link>

                {!company ? (
                  <div>
                    <h4 style={{ fontSize: "24px" }}>
                      Hello! let's get started
                    </h4>
                    <h6
                      className="font-weight-light"
                      style={{ fontSize: "16px" }}
                    >
                      Sign in to continue.
                    </h6>
                    <form className="pt-3">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control form-control-lg"
                          id="exampleInputEmail1"
                          placeholder="Email"
                          name="email"
                          onChange={handleChange}
                        />
                        {simpleValidator.current.message(
                          "email",
                          formData.email,
                          "required|email",
                          { className: "text-danger" }
                        )}
                      </div>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control form-control-lg"
                          id="exampleInputPassword1"
                          placeholder="Password"
                          name="password"
                          onChange={handleChange}
                        />
                        {simpleValidator.current.message(
                          "password",
                          formData.password,
                          "required",
                          { className: "text-danger" }
                        )}
                      </div>
                      <div className="text-danger">{errorPassword} </div>
                    </form>
                    <div className="mt-2">
                      <div
                        className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn pt-3"
                        onClick={handleSubmit}
                      >
                        SIGN IN
                      </div>
                    </div>

                    <div
                      className="text-center mt-4 font-weight-light"
                      style={{ fontSize: "14px" }}
                    >
                      {" "}
                      Don't have an account?
                      <Link to="/register">
                        {" "}
                        <a href="register.html" className="text-primary">
                          Create Account
                        </a>
                      </Link>
                    </div>
                    {/* <div
                      className="text-center mt-2 font-weight-light"
                      style={{ fontSize: "14px" }}
                    >
                      <Link to="/register">
                        <a href="register.html" className="text-primary">
                          Forgot Password?
                        </a>
                      </Link>
                    </div> */}
                  </div>
                ) : (
                  <Company id={id} name={name} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress />
      </Backdrop>
    </div>
  );
}
